import { useCallback, useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { ProductService } from '../../services/product/productService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage product fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de productos.
----------------------------------------------------------------------------------------*/

const useProducts = () => {

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);

    const fetchProducts = useCallback(async () => {
        try {
            if (!userCan('list', 'product')) return;   
            const service = new ProductService();
            const response = await service.listForSelect({ limit: 999999 });
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; purchasePrice: number; }) => ({
                    value: data.id,
                    label: data.name,
                    purchasePrice: data.purchasePrice,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching products:', error);
        }
    }, []);

    useEffect(() => {
        fetchProducts();
    }, []);

    const getProductsList = () => {
        return data;
    };

    const getProductPrice = (productId: string): number => {
        const product = data.find(p => p.value === productId);
        return product?.purchasePrice || 0;
    };

    return { 
        fetchProducts, 
        getProductsList, 
        getProductPrice
    };    
}

export default useProducts;
